"use client";

import React from "react";

const Whatis = () => {
  return (
    <section className="py-20 border-b border-gray-800 bg-gray-800">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-semibold text-center mb-12 text-white">
          Why Peerquik? The Next.js Boilerplate for B2C & P2P Marketplaces
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              title: "Tailored for B2C Marketplaces",
              content: "Built-in buyer/seller authentication, listings, reviews, and admin panel—everything for rapid B2C and P2P marketplace development with Next.js.",
            },
            {
              title: "Launch B2C Apps Fast",
              content: "Docker setup, SEO tools, and cron jobs empower your Next.js boilerplate to launch B2C marketplaces in days, saving 500+ hours.",
            },
            {
              title: "Customizable for Your Vision",
              content: "Flexible Supabase/Postgres, Vercel or VPS deployment, and integrations like Resend and Google OAuth for your B2C marketplace app.",
            },
          ].map((card, i) => (
            <div
              key={i}
              className="bg-gray-900 p-6 rounded-lg shadow-lg border-t-4 border-cyan-500 hover:shadow-xl transition"
            >
              <h3 className="text-lg font-medium text-cyan-400 mb-3">{card.title}</h3>
              <p className="text-base text-gray-300 leading-relaxed">{card.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Whatis;